// @unocss-include
import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmedButton } from '@a-type/ui';
import { useHasServerAccess } from '../hooks/graphql.js';
export function ResetToServer({ clientDescriptor, }) {
    const canSync = useHasServerAccess();
    if (!canSync)
        return null;
    return (_jsx(ConfirmedButton, { color: "destructive", confirmText: "This will reset your local data to the server's version.", onConfirm: () => {
            clientDescriptor.__dangerous__resetLocal();
        }, children: "Reset local data" }));
}
//# sourceMappingURL=ResetToServer.js.map